<template>
  <div>
    <search-list @findData="findData"></search-list>
    <div class="page-wrapper">
      <Button type="primary" class="mb16" @click.stop="toAdd" v-p="{api:'invoice/saveInvoiceInfo'}">新增</Button>
      <table-list
        title="" :columns="columns" :data="data" :loading="loading" :total="total" :current="current" @change-page="changePage"
      ></table-list>
    </div>
    <add :n="addN" @done="invoicelist"></add>
    <detail :n="detailN" :invoiceFid="invoiceFid"></detail>
  </div>
</template>
<script>
  import SearchList from './components/SearchList'
  import TableList from "components/TableList/index";
  import {invoicelist} from "../../../api/invoice";
  import Add from './components/Add'
  import Detail from './components/Detail'
  import {applycancel} from "../../../api/invoice";
  import {formatMoney} from "../../../utils/format";

  export default {
    name: "invoiceapply",
    components:{
      SearchList,
      TableList,
      Add,
      Detail
      // Update
    },
    data(){
      return {
        detailN:0,
        invoiceFid:'',
        addN:0,
        loading:false,
        total:0,
        current:1,
        columns:[
          {
            type:'index',
            width:60,
            align:'center'
          },
          {
            title:' '
          },
          {
            title: "发票抬头",
            key: "invoiceTitle",
            align: "center",
            width:160,
          },
          {
            title:' '
          },
          {
            title: "费用项",
            key: "feeTypeTxt",
            align: "center",
            width:100,
          },
          {
            title:' '
          },
          {
            title: "金额",
            key: "invoiceAmount",
            align: "center",
            width:120,
            render:(h,params)=>{
              return h('span',{},(params.row['invoiceAmount']&& params.row['invoiceAmount']!==0)?formatMoney(Number(params.row['invoiceAmount']).toFixed(2)):'-')
            }
          },
          {
            title:' '
          },
          {
            title: "开票周期",
            key: "circle",
            align: "center",
             width:200,
            render:(h,params)=>{
              return h('span',{},params.row['applyStartMonth']+'至'+params.row['applyEndMonth'])
            }
          },
          {
            title:' '
          },
          {
            title: "发票类别",
            key: "invoiceTypeTxt",
            align: "center",
             width:120,
          },
          {
            title:' '
          },
          {
            title: "发票状态",
            key: "status",
            align: "center",
             width:100,
            render:(h,params)=>{
              if(params.row['invoiceSource']===1){
                if(params.row['opResult']===7){
                  return h('span',{
                    style:{
                      color:'red'
                    },
                  },params.row['opResultTxt'])
                }
                else {
                  return h('span',{},params.row['opResultTxt'])
                }
              }
              else {
                return h('span',{},params.row['statusTxt'])
              }
            }
          },
          {
            title:' '
          },
          {
            title: "申请时间",
            key: "applyTime",
            align: "center",
            width:160,
          },
          {
            title:' '
          },
          {
            title: "房间号",
            key: "stockNumber",
            align: "center",
            width:120,
          },
          {
            title:' '
          },
          {
            title: "合同号",
            key: "contractCode",
            align: "center",
            width:180,
          },
          {
            title:' '
          },
          {
            title: "主合同号",
            key: "parentContractCode",
            align: "center",
            width:160,
          },
          {
            title:' '
          },
          {
            title: "项目名称",
            key: "projectName",
            align: "center",
           width:160,
          },
          {
            title:' '
          },
          {
            title: "财务联系人",
            key: "financeContact",
            align: "center",
            width:100
          },
          {
            title:' '
          },
          {
            title: "联系电话",
            key: "financeContactPhone",
            align: "center",
            width:120
          },
          {
            title:' '
          },
          {
            title: "操作",
            key: "action",
            align: "center",
            fixed:'right',
            width:150,
            render:(h,params)=>{
              let invalidate=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'invoice/apply/cancel'
                    }
                  }
                ],
                style:{
                  marginRight:'10px'
                },
                on:{
                  click:()=>{
                    this.applycancel(params.row['fid'])
                  }
                }
              },'取消')
              let detail=h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'invoice/getInvoiceInfoByFid'
                    }
                  }
                ],
                style:{
                  marginRight:'10px'
                },
                on:{
                  click:()=>{
                    this.invoiceFid=params.row['fid']
                    this.detailN++
                  }
                }
              },'查看')
              let actions=[detail]


              if(params.row['invoiceSource']===0){
                if(["01","02"].indexOf(params.row['status'])!==-1){
                  actions.push(invalidate)
                }

              }
              else {
                if([0,7].indexOf(params.row['opResult'])!==-1){
                  actions.push(invalidate)
                }
              }

              return h('div',{},actions)
            }
          },
        ],
        data:[],
        searchData:{
          "applyEndTime": "",
          "applyStartTime": "",
          "contractCode": "",
          "feeType": "",
          "invoiceSource": '',
          "invoiceTitle": "",
          "invoiceType": '',
          "limit": 10,
          "page": 1,
          "projectFid": "",
          "projectFids": "",
          "stockNumber": ""
        }
      }
    },
    methods:{
      formatMoney:formatMoney,
      applycancel(invoiceFid){
        this.$Modal.confirm({
          title:'作废发票',
          content:'<p>确认作废本条发票？</p>',
          onOk:()=>{
            let params={
              invoiceFid:invoiceFid
            }
            applycancel(params).then(res=>{
              this.$Message.success('该发票已作废')
              this.invoicelist()
            }).catch(error=>{})
          }
        })
      },
      invoicelist(){
        invoicelist(this.searchData).then(res=>{
          this.data=res.data.rows
          this.total=res.data.total
        }).catch(error=>{})
      },
      toAdd(){
        this.addN++
      },
      findData(params){
        this.current=1
        this.searchData = Object.assign({}, params);
        this.invoicelist();
      },
      changePage(n){
        this.current=n
        this.searchData.page = n;
        this.invoicelist();
      }
    },
    created(){
      this.invoicelist()
    }
  }
</script>

<style scoped>

</style>
